import React, { useCallback, useEffect, useRef } from "react";

/**
 * 随内容自适应增高的 textarea
 * 最大高度到 maxHeight 后内部出滚动
 */
const AutoGrowTextarea = ({ value, onChange, className = "", style = {}, minRows = 1, maxHeight = 240, ...props }) => {
  const ref = useRef(null);
  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const nextHeight = Math.min(el.scrollHeight, maxHeight);
    el.style.height = `${nextHeight}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  }, [maxHeight]);

  useEffect(() => {
    resize();
  }, [resize, value]);

  return (
    <textarea
      ref={ref}
      value={value}
      rows={minRows}
      onChange={(event) => {
        onChange?.(event);
        requestAnimationFrame(resize);
      }}
      className={`resize-none ${className}`}
      style={{ ...style, resize: "none" }}
      {...props}
    />
  );
};

export default AutoGrowTextarea;
